import axios from 'axios'
import { host } from '../../helper/config'

const PLUGINS_NAME = 'admin-messaging'

export const submitFbToken = async (token, fbToken) => {
    const response = await axios.post(`${host}/${PLUGINS_NAME}/submit-token`, {
        token: fbToken
    }, {
        headers: {
            'Access-Control-Allow-Origin': '*',
            'Content-Type': 'application/json',
            'Authorization': token
        },
    })

    if (response && response.status === 200) {
        return response.data || {}
    }
    return {}
}
